import { telegram } from '../telegram/bridge';

export interface RuntimeIdentity {
  id: number;
  username?: string;
  firstName?: string;
  languageCode?: string;
}

export interface RuntimeAdapter {
  readonly kind: 'telegram' | 'browser';
  isAvailable(): boolean;
  initData(): string;
  identity(): RuntimeIdentity | null;
  languageCode(): string;
  startParam(): string;
  platform(): string;
  initialize(): void;
  awaitReady(): ReturnType<typeof telegram.awaitReady>;
  resyncViewport(): void;
  showBack(handler: () => void): () => void;
  openExternal(url: string): void;
  openTelegram(url: string): void;
  supportsNativeDownload(): boolean;
  downloadFile(value: { url: string; file_name: string }): Promise<boolean>;
  share(value: ShareData): Promise<boolean>;
  haptic(kind?: Parameters<typeof telegram.haptic>[0]): void;
  lockEditorGestures(locked: boolean): void;
  close(): void;
}

const browserOpen = (url: string) => {
  const parsed = new URL(url, window.location.href);
  if (!['https:', 'http:'].includes(parsed.protocol)) return;
  window.open(parsed.toString(), '_blank', 'noopener,noreferrer');
};

export const runtime: RuntimeAdapter = {
  kind: telegram.isAvailable() ? 'telegram' : 'browser',
  isAvailable: telegram.isAvailable,
  initData: telegram.initData,
  identity: () => {
    const user = telegram.user();
    return user ? { id: user.id, username: user.username, firstName: user.first_name, languageCode: user.language_code } : null;
  },
  languageCode: telegram.languageCode,
  startParam: telegram.startParam,
  platform: telegram.platform,
  initialize: telegram.initialize,
  awaitReady: telegram.awaitReady,
  resyncViewport: telegram.resyncViewport,
  showBack: telegram.showBack,
  openExternal: browserOpen,
  openTelegram: telegram.openTelegramLink,
  supportsNativeDownload: telegram.supportsNativeDownload,
  downloadFile: telegram.downloadFile,
  share: async (value) => {
    if (!navigator.share) return false;
    try { await navigator.share(value); return true; } catch { return false; }
  },
  haptic: telegram.haptic,
  lockEditorGestures: telegram.lockEditorGestures,
  close: telegram.close,
};
